// Lazily-created Laravel Echo client (Reverb / pusher protocol) for the
// community 1-to-1 chat. Members authenticate to private channels with their
// encrypted member token via the custom /community-chat-auth endpoint rather
// than a Laravel session, so we provide a custom authorizer.
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import axios from "axios";
import config from "./config";

window.Pusher = Pusher;

let echoInstance = null;
let echoKey = null;

// Reverb client settings. Defaults match the local .env; production should set
// REACT_APP_REVERB_* (the app key is a public client key, safe to ship).
const REVERB_KEY = process.env.REACT_APP_REVERB_KEY || "5os5n9thfqxwyxczaiev";
const REVERB_HOST = process.env.REACT_APP_REVERB_HOST || "localhost";
const REVERB_PORT = Number(process.env.REACT_APP_REVERB_PORT || 8080);
const REVERB_SCHEME = process.env.REACT_APP_REVERB_SCHEME || "http";

/**
 * Get (or build) the shared Echo instance for the given member. Rebuilt if the
 * community/member identity changes. Returns null if identity is missing.
 */
export function getEcho({ communityToken, memberToken }) {
  if (!communityToken || !memberToken) return null;

  const key = `${communityToken}:${memberToken}`;
  if (echoInstance && echoKey === key) return echoInstance;
  if (echoInstance) {
    try {
      echoInstance.disconnect();
    } catch (e) {
      /* ignore */
    }
    echoInstance = null;
  }

  echoInstance = new Echo({
    broadcaster: "reverb",
    key: REVERB_KEY,
    wsHost: REVERB_HOST,
    wsPort: REVERB_PORT,
    wssPort: REVERB_PORT,
    forceTLS: REVERB_SCHEME === "https",
    enabledTransports: ["ws", "wss"],
    authorizer: (channel) => ({
      authorize: (socketId, callback) => {
        axios
          .post(`${config.COMMUNITY_API_URL}/community-chat-auth`, {
            community_token: communityToken,
            member_token: memberToken,
            socket_id: socketId,
            channel_name: channel.name,
          })
          .then((res) => callback(null, res.data))
          .catch((err) => callback(err, null));
      },
    }),
  });
  echoKey = key;
  return echoInstance;
}

export function teardownEcho() {
  if (echoInstance) {
    try {
      echoInstance.disconnect();
    } catch (e) {
      /* ignore */
    }
  }
  echoInstance = null;
  echoKey = null;
}
